import configureReduxStore from './configureStore';

const store = configureReduxStore();

export default store;
